export const next = (r) => {
    if (typeof r === "string") {
        // Check if the input string is an empty string


        if (!r) {
            return "";
        }

        if(r === "new_a") {
            return "A";
        }

        if(r === "new_1"){ 
            return 1;
        }

        // Check if the input string starts with 'P' followed by a number
        if (/^P\d+$/.test(r)) {
            const num = parseInt(r.substring(1), 10);
            return `P${num + 1}`;
        }


        // Check if the input string is a number
        const num = parseInt(r, 10);
        if (!isNaN(num)) {
            return num + 1;
        }

        // Alphabetical revisions, including multi-letter (A → B, Z → AA, AA → AB, AZ → BA)
        if (/^[a-zA-Z]+$/.test(r)) {
            const chars = [...r];

            for (let i = chars.length - 1; i >= 0; i--) {
                const base = (chars[i] >= "a" && chars[i] <= "z" ? "a" : "A").charCodeAt(0);
                const code = chars[i].charCodeAt(0);

                if (code < base + 25) {
                    chars[i] = String.fromCharCode(code + 1);
                    return chars.join("");
                }

                chars[i] = String.fromCharCode(base);
            }

            const firstBase = r[0] >= "a" && r[0] <= "z" ? "a" : "A";
            return firstBase + chars.join("");
        }

        // Return an empty string for any other input string
        return "";
    }
    else if (typeof r === "number") {
        return r + 1;
    }

    // Return undefined for any other data type
    return undefined;
};

export const isPrototypeRevision = (revision) => /P\d+/.test(String(revision ?? ""));

export const pad = (num = "", size = 4) => {
    // Convert the input to a string if it's not already a string
    num = num.toString();

    // Calculate the number of characters to pad
    const padding = size - num.length;

    // Return the padded string
    return padding > 0 ? "0".repeat(padding) + num : num;
};

// This function flattens an object into a single-level object, where the keys are separated by a specified separator.
export const flattenObject = (obj, keySeparator = '/') => {
    // The resulting flattened object
    const propertyMap = {};

    // A stack to keep track of the objects and their prefixes
    const stack = [{ obj, prefix: '' }];

    // Use an iterative approach to traverse the object
    while (stack.length) {
        // Pop the next object and prefix from the stack
        const { obj, prefix } = stack.pop();

        // Iterate over the entries in the current object
        for (const [key, value] of Object.entries(obj)) {
            // Construct the property name using the prefix and key
            const property = prefix ? `${prefix}${keySeparator}${key}` : key;

            // If the value is an object, push it onto the stack with the updated prefix
            if (value && typeof value === 'object') {
                stack.push({ obj: value, prefix: property });
            } else {
                // Otherwise, add the property to the propertyMap
                propertyMap[property] = value;
            };
        };
    };
    // Return the propertyMap
    return propertyMap;
};

export const standardDateLocal = {
    "year": "numeric",
    "month": "long",
    "day": "numeric",
};

export const addToRecents = ({ currentRoute, pageItem, store, db }) => {
    if (!pageItem || !pageItem.Number) return;
    const newRecents = [
        ...(store.state.user.Recents || []),
        {
            link: currentRoute.path,
            name: pageItem.Number,
            time: new Date().toISOString(),
            type: currentRoute.meta.name
        },
    ];
    const recents = [...newRecents]
        .sort((left, right) => new Date(right.time) - new Date(left.time))
        .filter((item, index, items) => items.findIndex(entry => entry.name === item.name) === index)
        .slice(0, 10);
        try {
            db.set(`Userdata/${store.state.user.ID}/Recents/`, recents);

        } catch(err) {
            
        }
};

export const makeDropdown = (store, array = [], labelKey, idKey) => {
    let x = array
        .map(i => store.state[i])
        .filter(i => !!i)
        .map(i => ({ "label": i[labelKey], "id": i[idKey], "meta": i }));
    return x;
};

export const makeAttached = (array, value = true) => {
    if (Array.isArray(array) && array.length > 0) return Object.fromEntries(array.map(i => ([i, value])));
    else if (typeof array === "string") return { [array]: value };
    else return [];
};

export const keepArray = (array) => {
    if (Array.isArray(array)) return array
    else return [array];
};

export const appConfig = JSON.parse(import.meta.env.VITE_APP_CONFIG);
